import * as React from 'react';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { Input } from '@independent-software/typeui/controls/Input'

interface IProps {
  value: string;
  onSearch: (value: string) => void;
}

const SearchFilter = (props: IProps) => {
  const [value, setValue] = React.useState(props.value);

  const setFilterSearch = (value:string) => {
    props.onSearch(value);
  }
  const handleChangeFilterSearchDebounced = AwesomeDebouncePromise(setFilterSearch, 350);
  const handleChange = async(newvalue: string) => { 
    setValue(newvalue);
    handleChangeFilterSearchDebounced(newvalue);
  }  

  return(
    <Input clearable fluid name="search" icon="search" type="text" value={value} placeholder="Search" onChange={handleChange}/>
  );
}

export { SearchFilter }
